function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppPlus = function SvgIcLogicGAppPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-33.3 0h20v20h-20z",
    style: {
      fill: "none"
    },
    transform: "translate(33.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.7 9.3h-2.9V6.4c0-.4-.3-.7-.7-.7s-.7.3-.7.7v2.9h-2.9c-.4 0-.7.3-.7.7s.3.7.7.7h2.9v2.9c0 .4.3.7.7.7s.7-.3.7-.7v-2.9h2.9c.4 0 .7-.3.7-.7s-.3-.7-.7-.7",
    style: {
      fill: "currentColor"
    },
    transform: "translate(33.334)"
  }));
};
export default SvgIcLogicGAppPlus;